import events from '@/constants/events'
import EventBus from '@/EventBus'

/**
 * This shows confirmation Dialog
 * @param body
 * @param title
 * @param variant
 * @param callback
 * @param cancelCallback
 * @param okTitle
 * @param cancelTitle
 */
export default payload => {
  EventBus.$emit(events.CONFIRM_DIALOG, payload)
}
